export const API_URL: string = import.meta.env.VITE_API_URL || 'https://apigo2.com/api';
export const IS_PRODUCTION: boolean = import.meta.env.PROD;
export const TEX_API_URL: string = import.meta.env.VITE_TEX_API_URL as string;
